import * as React from 'react';
import { NavLink, generatePath, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/auth';
import { useConfig } from '../hooks/config';
import { useGetCategoriesQuery, useGetDietsQuery } from '../services/recipes';
import { Box, Drawer, Link, List, ListItem, ListItemButton as MuiListItemButton, ListItemIcon, ListItemText, IconButton, Collapse } from '@mui/material';
import { styled } from '@mui/material/styles';
import { CloseSimpleIcon, DishIcon } from './Icons';
import Img from './Img';
import homeIcon from '../assets/icons/png/home.png';
import recipesMenuIcon from '../assets/icons/png/recipes.png';
import newsletterIcon from '../assets/icons/png/newsletter.png';
import workIcon from '../assets/icons/png/work.png';
import coursesMenuIcon from '../assets/icons/png/academia.png';
import blogIcon from '../assets/icons/png/blog.png';
import CircleIcon from '@mui/icons-material/Circle';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const ListItemIconContainer = styled(Box)(({ theme }) => ({
  backgroundColor: '#F5F1EA',
  padding: theme.spacing(1, 1, 0.5, 1),
  borderRadius: 15,
}));

const ListItemButton = styled(MuiListItemButton)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    paddingLeft: theme.spacing(7)
  },
  '&.active': {
    color: theme.palette.primary.main,
    '& .iconContainer': {
      backgroundColor: theme.palette.primary.main
    }
  }
}));

const MenuItems = (props) => {

  const { setOpen } = props;
  const { auth, user } = useAuth();
  const { config } = useConfig();
  const { data: categories } = useGetCategoriesQuery();
  const { data: diets } = useGetDietsQuery();
  const [ openMenu, setOpenMenu ] = React.useState({});

  return (
    <Box
      sx={{ 
        width: {
          xs: '100vw',
          sm: '30vw'
        },
        maxWidth: 650,
        minWidth: 250,
        /*minHeight: {
          xs: '100vh',
          md: '100%'
        },
        backgroundColor: (theme) => theme.palette.cream.main */ 
      }}
      role="presentation"
    >
      <Box
        textAlign="right"
        pt={1}
        pr={1}
      >
        <IconButton 
          color="dark"
          onClick={() => setOpen(false)}
        >
          <CloseSimpleIcon />
        </IconButton>
      </Box>
      <List sx={{py:0}}>
        <ListItem 
          disablePadding
        >
          <ListItemButton
            component={NavLink}
            to="/"
          >
            <ListItemIcon sx={{mr: 2}}>
              <ListItemIconContainer className="iconContainer">
                <Img src={homeIcon} sx={{width: 36, height: 36}} />
              </ListItemIconContainer>
            </ListItemIcon>
            <ListItemText>
              <b>Home</b>
            </ListItemText>
          </ListItemButton>
        </ListItem>
        <ListItem 
          disablePadding
        >
          <ListItemButton
            onClick={() => setOpenMenu({categories: !Boolean(openMenu.categories)})}
          >
            <ListItemIcon sx={{mr: 2}}>
              <ListItemIconContainer className="iconContainer">
                <Img src={recipesMenuIcon} sx={{width: 36, height: 36}} />
              </ListItemIconContainer>
            </ListItemIcon>
            <ListItemText>
              <b>Ricette</b>
            </ListItemText>
            { !Boolean(openMenu.categories) ? <KeyboardArrowDownIcon sx={{fontSize: '2rem !important'}} /> : <KeyboardArrowUpIcon sx={{fontSize: '2rem !important'}} />}
          </ListItemButton>
        </ListItem>
        {
          Boolean(categories) &&
          <Collapse in={Boolean(openMenu.categories)}>
            <ListItem disablePadding>
              <ListItemIcon sx={{mr: 2}} />
              <List>
                {
                  categories.map((category) => (
                    <ListItem 
                      key={category.id}
                      disablePadding
                    >
                      <ListItemButton
                        component={NavLink}
                        to={generatePath('/categorie/:slugCategory', {slugCategory: category.slug})}
                        color="dark.main"
                        sx={{
                          p: 0,
                          pl: (theme) => ({
                            md: theme.spacing(5) + '!important'
                          }),
                          '&.active': {
                            color: (theme) => theme.palette.primary.main
                          }
                        }}
                      >
                        <ListItemIcon sx={{color: 'inherit', minWidth: 'auto', mr: 1}}>
                          <CircleIcon color="inherit" sx={{width: 5, height: 5}} />
                        </ListItemIcon>
                        <ListItemText sx={{m:0}}>
                          {category.name}
                        </ListItemText>
                      </ListItemButton>
                    </ListItem>
                  ))
                }
                <ListItem 
                  disablePadding
                >
                  <ListItemButton
                    component={NavLink}
                    to="/ricette"
                    color="dark.main"
                    sx={{
                      p: 0,
                      pl: (theme) => ({
                        md: theme.spacing(5) + '!important'
                      }),
                      '&.active': {
                        color: (theme) => theme.palette.primary.main
                      }
                    }}
                  >
                    <ListItemIcon sx={{color: 'inherit', minWidth: 'auto', mr: 1}}>
                      <CircleIcon color="inherit" sx={{width: 5, height: 5}} />
                    </ListItemIcon>
                    <ListItemText sx={{m:0}}>
                      Tutte le ricette
                    </ListItemText>
                  </ListItemButton>
                </ListItem>
              </List>
            </ListItem>
          </Collapse>
        }
        <ListItem 
          disablePadding
        >
          <ListItemButton
            onClick={() => setOpenMenu({diets: !Boolean(openMenu.diets)})}
          >
            <ListItemIcon sx={{mr: 2}}>
              <ListItemIconContainer className="iconContainer">
                <DishIcon />
              </ListItemIconContainer>
            </ListItemIcon>
            <ListItemText>
              <b>Tipi di Cucina</b>
            </ListItemText>
            { !Boolean(openMenu.diets) ? <KeyboardArrowDownIcon sx={{fontSize: '2rem !important'}} /> : <KeyboardArrowUpIcon sx={{fontSize: '2rem !important'}} />}
          </ListItemButton>
        </ListItem>
        {
          Boolean(diets) &&
          <Collapse in={Boolean(openMenu.diets)}>
            <ListItem disablePadding>
              <ListItemIcon sx={{mr: 2}} />
              <List>
                {
                  diets.items.map((diet) => (
                    <ListItem 
                      key={diet.id}
                      disablePadding
                    >
                      <ListItemButton
                        component={NavLink}
                        to={generatePath('/diete/:slugDiet', {slugDiet: diet.slug})}
                        color="dark.main"
                        sx={{
                          p: 0,
                          pl: (theme) => ({
                            md: theme.spacing(5) + '!important'
                          }),
                          '&.active': {
                            color: (theme) => theme.palette.primary.main
                          }
                        }}
                      >
                        <ListItemIcon sx={{color: 'inherit', minWidth: 'auto', mr: 1}}>
                          <CircleIcon color="inherit" sx={{width: 5, height: 5}} />
                        </ListItemIcon>
                        <ListItemText sx={{m:0}}>
                          {diet.name}
                        </ListItemText>
                      </ListItemButton>
                    </ListItem>
                  ))
                }
              </List>
            </ListItem>
          </Collapse>
        }
        {
          Boolean(config) &&
          <ListItem 
            disablePadding
          >
            <ListItemButton
              component={Link}
              href={config.url_blog}
            >
              <ListItemIcon sx={{mr: 2}}>
                <ListItemIconContainer className="iconContainer">
                  <Img src={blogIcon} sx={{width: 36, height: 36}} />
                </ListItemIconContainer>
              </ListItemIcon>
              <ListItemText>
                <b>Blog</b>
              </ListItemText>
            </ListItemButton>
          </ListItem>
        }
        {
          (!auth || (auth && !user.flag_newsletter)) &&
          <ListItem 
            disablePadding
          >
            <ListItemButton
              component={NavLink}
              to="/newsletter"
            >
              <ListItemIcon sx={{mr: 2}}>
                <ListItemIconContainer className="iconContainer">
                  <Img src={newsletterIcon} sx={{width: 36, height: 36}} />
                </ListItemIconContainer>
              </ListItemIcon>
              <ListItemText>
                <b>Newsletter</b>
              </ListItemText>
            </ListItemButton>
          </ListItem>
        }
        <ListItem 
            disablePadding
          >
          <ListItemButton
            component={NavLink}
            to="/academia"
          >
            <ListItemIcon sx={{mr: 2}}>
              <ListItemIconContainer className="iconContainer">
                <Img src={coursesMenuIcon} sx={{width: 36, height: 36}} />              
              </ListItemIconContainer>
            </ListItemIcon>
            <ListItemText>
              <b>Corsi di cucina online</b>
            </ListItemText>
          </ListItemButton>
        </ListItem>
        <ListItem 
            disablePadding
          >
            <ListItemButton
              component={NavLink}
              to="/lavora-con-noi"
            >
              <ListItemIcon sx={{mr: 2}}>
                <ListItemIconContainer className="iconContainer">
                  <Img src={workIcon} sx={{width: 36, height: 36}} />
                </ListItemIconContainer>
              </ListItemIcon>
              <ListItemText>
                <b>Lavora con noi</b>
              </ListItemText>
            </ListItemButton>
          </ListItem>
      </List>
    </Box>
  );
}

const Sidebar = (props) => {

  const { open, setOpen } = props;
  const location = useLocation();

  React.useEffect(() => {
    setOpen(false);
  }, [location])

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={() => setOpen(false)}
      sx={{
        '& .MuiPaper-root': {
          backgroundColor: (theme) => theme.palette.cream.main
        }  
      }}
    >
      <MenuItems setOpen={setOpen} />
    </Drawer>
  );
}

export default Sidebar;
